import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { getUser } from "./helpers/user";

const PrivateLayout = () => {
  const user = getUser();

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default PrivateLayout;
